import {
  Component, EventEmitter, Input, OnInit, Output,
} from '@angular/core';
import { CourseFilter } from '../../courseFilter';

@Component({
  selector: 'app-general-course-filters',
  templateUrl: './general-course-filters.component.html',
  styleUrls: [ './general-course-filters.component.scss' ],
})
export class GeneralCourseFiltersComponent implements OnInit {
  @Input() mainFilter: CourseFilter;
  @Input() hasPermission = false;
  @Output() updateMainFilter = new EventEmitter<object>();


  privilegedFilters: { text: string, parameter: keyof CourseFilter }[] = [
    { text: 'Show User View', parameter: 'showUserViewFlag' },
    { text: 'Show Inactive courses', parameter: 'showInactiveCoursesFlag' },
    { text: 'Show cancelled courses', parameter: 'showCancelledCoursesFlag' },
  ];

  basicList: {text: string, parameter: keyof CourseFilter}[] = [
    { text: 'Show async', parameter: 'showAsyncFlag' },
    { text: 'Show anytime courses', parameter: 'showAnytimeCoursesFlag' },
    { text: 'Show virtual', parameter: 'showVirtualFlag' },
    { text: 'Show outside courses', parameter: 'showOutsideCoursesFlag' },
    { text: 'Show waitlisted courses', parameter: 'showWaitlistedCoursesFlag' },
  ]

  checkboxList: { text: string, parameter: keyof CourseFilter }[] = [];


  ngOnInit(): void {
    if (this.hasPermission) {
      this.hasPermission = true;
      this.checkboxList = [ ...this.basicList, ...this.privilegedFilters ]
    } else {
      this.hasPermission = false;
      this.checkboxList = [ ...this.basicList ]
    }
  }

  updateCheckboxFilter(parameter: keyof CourseFilter, event: any): void {
    (this.mainFilter[parameter] as boolean) = event.target.checked;
  }

  updateFilter(parameter: keyof CourseFilter, event: any): void {
    (this.mainFilter[parameter] as string)= event.target.value as string;
  }

  resetGeneralFilters(): void {
    this.mainFilter.resetGeneral(this.hasPermission);
    const otherFilters = [
      'startDate', 'endDate', 'hours',
    ];
    otherFilters.forEach((filter) => {
      this.updateMainFilter.emit({ parameter: filter, value: '' });
    });
  }

  getHelpText(parameter: keyof CourseFilter): string {
    const helpTexts: { [key: string]: string } = {
      'showUserViewFlag': 'Show courses with user-specific information and personalized content',
      'showInactiveCoursesFlag': 'Include courses that are currently inactive or not available for enrollment',
      'showCancelledCoursesFlag': 'Display courses that have been cancelled but may still be visible for reference',
      'showAsyncFlag': 'Show asynchronous courses that can be completed at your own pace',
      'showAnytimeCoursesFlag': 'Include courses that are available anytime without specific scheduling requirements',
      'showVirtualFlag': 'Display virtual or online courses that are conducted remotely',
      'showOutsideCoursesFlag': 'Show courses that are offered outside of the standard curriculum',
      'showWaitlistedCoursesFlag': 'Include courses where you are currently on the waitlist',
      'showCourseRequestsFlag': 'Display course requests that are pending approval or processing',
      'showPreviousHoursFlag': 'Show courses from previous periods or semesters for historical reference',
    };

    return helpTexts[parameter] || 'Additional filter option for course display';
  }
}
